// src/utils/tokenCookie.ts
import Cookies from "universal-cookie";

const cookies = new Cookies();
export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";

export const getAccessToken = () => cookies.get(ACCESS_TOKEN_KEY) as string | undefined;
export const getRefreshToken = () => cookies.get(REFRESH_TOKEN_KEY) as string | undefined;

export const setTokens = (accessToken: string, refreshToken?: string) => {
  console.log("setTokens", { accessToken, refreshToken });
  cookies.set(ACCESS_TOKEN_KEY, accessToken, { path: "/", sameSite: "lax" });
  if (refreshToken) cookies.set(REFRESH_TOKEN_KEY, refreshToken, { path: "/", sameSite: "lax" });
};

export const clearTokens = () => {
  cookies.remove(ACCESS_TOKEN_KEY, { path: "/" });
  cookies.remove(REFRESH_TOKEN_KEY, { path: "/" });
};

// ✅ base64url → base64 (padding 포함)로 안전 디코드
function decodeJwtPayload(token: string): any | null {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    let payload = parts[1]; // base64url

    payload = payload.replace(/-/g, "+").replace(/_/g, "/");

    // ✅ padding '=' 보정
    const pad = payload.length % 4;
    if (pad) payload += "=".repeat(4 - pad);

    const json = atob(payload);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

// ✅ leeway(예: 30초) 주면 만료 직전 튕김도 줄어듦
export function isJwtExpired(token: string, leewaySeconds = 30): boolean {
  const payload = decodeJwtPayload(token);
  const exp = Number(payload?.exp);
  if (!exp) return true; // exp 없으면 안전하게 만료 취급(원하면 false로 바꿔도 됨)

  const nowSec = Math.floor(Date.now() / 1000);
  return exp <= nowSec + leewaySeconds;
}

export const isAuthed = (): boolean => {
  return !!getAccessToken(); // 만료 체크 제거
};
